<div class="fc-view fc-agendaWeek-view fc-agenda-view" (click)="hideMenu($event)">
  <table>
    <thead class="fc-head">
    <tr>
      <td class="fc-widget-header">
        <div class="fc-row fc-widget-header" style="border-right-width: 1px;">
          <table>
            <thead>
            <tr>
              <th class="fc-axis fc-widget-header" style="width:60px"></th>
              <th *ngFor="let day of days" class="fc-day-header fc-widget-header">
                {{ 'PAYROLL_PREPARE.weekday' | translate:{day: day | gpDayOfWeek} }}
              </th>
            </tr>
            <tr>
              <th class="fc-day fc-widget-content" style="width:60px"></th>
              <th *ngFor="let day of days" class="fc-day fc-widget-content">
                <div *ngIf="day.type !== 'OUT' && !isReadOnly" class="icon-btn pointer add-dropdown-btn"
                     (click)="onAddEventClick(day.date)">
                  <i class="fa fa-light fa-plus"></i>
                </div>
                <span class="pull-right">{{ day.date | date:'d' }}</span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="fc-axis" style="width:60px; height: 43px; text-align: center; white-space: normal;">
                {{ 'PAYROLL_PREPARE.all_day' | translate }}
              </td>
              <td *ngFor="let day of days">
                <div class="fc-event-container">
                  <gp-calendar-presence
                    *ngFor="let event of day.presences"
                    [event]="event"
                    [date]="day.date | date:'yyyy-MM-dd'"
                    [weekview]="true"
                    [isReadOnly]="isReadOnly || isEss"
                    (eventChanged)="onEventChanged(event)"
                    (click)="onEditEventClick(event, $event)">
                  </gp-calendar-presence>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
    </thead>
    <tbody class="fc-body">
    <tr>
      <td class="fc-widget-content">
        <hr class="fc-divider fc-widget-header">
        <div class="fc-time-grid-container fc-scroller" [style.height.px]="43 * workedHours + 2">
          <div class="fc-time-grid">
            <div class="fc-bg">
              <table>
                <tbody>
                <tr>
                  <td class="fc-axis fc-widget-content" style="width:60px"></td>
                  <td *ngFor="let day of days" class="fc-day fc-widget-content inside"
                      [class.fc-past]="day.isPast"
                      [class.fc-today]="day.isToday"
                      [class.fc-future]="day.isFuture"
                      [style.backgroundColor]="day.backgroundColor"
                      [style.color]="day.textColor">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="fc-slats">
              <table>
                <tbody>
                <tr *ngFor="let number of workedHours | gpArrayNumber" style="height:43px">
                  <td class="fc-axis fc-time fc-widget-content"
                      style="width: 60px; text-align: center; white-space: normal;">
                    <span>{{ number | gpOrdinal }} {{ 'PAYROLL_PREPARE.hour' | translate }}</span>
                  </td>
                  <td class="fc-widget-content"></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="fc-content-skeleton">
              <table>
                <tbody>
                <tr>
                  <td class="fc-axis" style="width:60px"></td>
                  <td *ngFor="let day of days"
                      class="fc-event-container inside no-margin {{day.cssClass}}"
                      [style.backgroundColor]="day.backgroundColor"
                      [style.color]="day.textColor">
                    <span class="day-label">{{day.label | translate}}</span>
                    <div>
                      <!--<gp-calendar-absence-->
                      <!--*ngFor="let event of day.absences"-->
                      <!--[event]="event"-->
                      <!--[workedHours]="workedHours"-->
                      <!--[weekview]="true"-->
                      <!--[date]="day.date | date:'yyyy-MM-dd'"-->
                      <!--[isReadOnly]="isReadOnly"-->
                      <!--(eventChanged)="onEventChanged(event)"-->
                      <!--(click)="onEditEventClick(event, $event)">-->
                      <!--</gp-calendar-absence>-->
                      <ng-container *ngFor="let event of day.absences; let absenceIndex = index">
                        <ng-container *ngIf="!event.attributes.status">
                          <gp-calendar-absence
                            [class.day-type-priority-on-absence]="day.hasPriorityOnAbsence[absenceIndex]"
                            [event]="event"
                            [workedHours]="workedHours"
                            [date]="day.date | date:'yyyy-MM-dd'"
                            [weekview]="true"
                            [isReadOnly]="isReadOnly"
                            (eventChanged)="onEventChanged(event)"
                            (resizeEvent)="onEventResize($event)"
                            (click)="onEditEventClick(event, $event)">
                          </gp-calendar-absence>
                        </ng-container>
                        <ng-container *ngIf="event.attributes.status">
                          <gp-calendar-pending-absence
                            [event]="event"
                            [workedHours]="workedHours"
                            [date]="day.date | date:'yyyy-MM-dd'"
                            [weekview]="true">
                          </gp-calendar-pending-absence>
                        </ng-container>
                      </ng-container>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
